import { render } from "./bind_templates.html?vue&type=template&id=49ce71f4&external"
import script from "./bind_templates?vue&type=script&lang=js&external"
export * from "./bind_templates?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__